// The shops a page shows products from. The CYO shops are unknown where they could not be loaded.
export type ShopIds = {
  marketplaceShopId: string | undefined;
  cyoShopId?: string;
  cyoEmbroideryShopId?: string;
};

// Which shop a displayed product belongs to: marketplace designs, CYO product types, or CYO
// product types offered for embroidery only.
export type Assortment = 'marketplace' | 'cyo' | 'cyo-embroidery';

export const getAssortment = (isEmbroideryOnly: boolean | undefined): Assortment =>
  isEmbroideryOnly ? 'cyo-embroidery' : 'cyo';

export const getShopIdForAssortment = (
  shopIds: ShopIds,
  assortment: Assortment
): string | undefined => {
  switch (assortment) {
    case 'cyo':
      return shopIds.cyoShopId;
    case 'cyo-embroidery':
      return shopIds.cyoEmbroideryShopId;
    default:
      return shopIds.marketplaceShopId;
  }
};
